import React, {useState, useEffect, useRef} from 'react';
import BannerERP from '../TTERP/BannerERP'
import DescripcionERP from '../TTERP/DescripcionERP'
import FichaTecnicaERP from '../TTERP/FichaTecnicaERP'
import DescripcionERPFondo from '../TTERP/DescripcionERPFondo'

export default function TTERP(props){

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);


    return(<>
    <BannerERP/>
    <div style={{height: '20px'}}></div>
    <DescripcionERP/>
    <div style={{height: '20px'}}></div>
    <FichaTecnicaERP/>
    <div style={{height: '20px'}}></div>
    <DescripcionERPFondo/>
    <div style={{height: '20px'}}></div>
    </>)
}